import { render } from "./CopyClipboard.vue?vue&type=template&id=18dee2bb"
import script from "./CopyClipboard.vue?vue&type=script&lang=js"
export * from "./CopyClipboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__